import posthog from 'posthog-js'

type AdditionalProperties = Record<string, unknown>

const sanitizeProperties = (properties: AdditionalProperties) => {
	return Object.fromEntries(
		Object.entries(properties).filter(([, value]) => value !== undefined)
	)
}

export function captureExceptionAndThrow(
	error: unknown,
	properties: AdditionalProperties
): never {
	const normalizedError =
		error instanceof Error ? error : new Error(String(error))

	try {
		posthog.captureException(
			normalizedError,
			sanitizeProperties(properties)
		)
	} catch (captureError) {
		console.warn('posthog.captureException failed', captureError)
	}

	throw error
}
